
<cradua-menu *ngIf="isLoggedIn$ | async"></cradua-menu>
<router-outlet></router-outlet>
